import React from 'react'

function HospitalMaster() {
  return (
    <div>Hospital Master</div>
  )
}

export default HospitalMaster